const actionTypes = require('../../actionTypes.js');
const stateBuilder = require("../../stateBuilder.js")
const logger = require("../../../logger/logger")

module.exports.createAction = function (fatalError)
{
    return (
        {
            type: actionTypes.fatalError,
            payload: fatalError.toString()
        }
    );
}

module.exports.changeState = function (previousState, payload)
{
    if (payload == null)
        return stateBuilder.createState();
    
    logger.error(payload);
    return Object.assign({}, previousState, { fatalError: payload });
}